<template>
  <CustomPage title="设置" right-text="保存" @onClickRight="onSubmit">
    <div slot="content" class="content">
      <Form ref="form">
        <Field
          label="头像"
          :center="true"
          input-align="right"
          right-icon="arrow"
        >
          <template #input>
            <Uploader
              :after-read="afterRead"
              :max-count="1"
              :deletable="false"
              :preview-image="false"
              right-icon="arrow"
            >
              <div
                class="avatar"
                :style="{ backgroundImage: 'url(' + avatar_c + ')' }"
              ></div>
            </Uploader>
          </template>
        </Field>
        <Field
          v-model="form.name"
          label="名称"
          placeholder="请输入名称"
          :rules="[{ validator: vaildName, message: '请输入两个字符以上' }]"
          input-align="right"
          error-message-align="right"
        />
        <Field
          readonly
          :value="form.areaName"
          label="所在地区"
          placeholder="点击选择省市区"
          right-icon="arrow"
          @click="showArea = true"
          input-align="right"
        />
        <Field
          v-model="form.address"
          label="详细地址"
          placeholder="请填写详细地址"
          input-align="right"
        />
        <Field
          v-model="form.contactName"
          label="联系人"
          placeholder="请输入联系人姓名"
          :rules="[{ validator: vaildName, message: '请正确输入姓名' }]"
          input-align="right"
          error-message-align="right"
        />
        <Field
          v-model="form.contactPhone"
          label="联系方式"
          placeholder="请输入联系方式"
          :rules="[{ validator: validPhone, message: '请正确输入手机号' }]"
          input-align="right"
          error-message-align="right"
        />
        <Field
          readonly
          :value="sex_c"
          label="性别"
          placeholder="请选择性别"
          right-icon="arrow"
          @click="showSex = true"
          input-align="right"
        />
        <Field
          readonly
          :value="form.birthDate"
          label="生日"
          placeholder="请选择生日"
          right-icon="arrow"
          @click="showBirthDate = true"
          input-align="right"
        />
      </Form>
      <Popup v-model="showArea" position="bottom">
        <Area
          :value="form.area"
          :area-list="areaList"
          @confirm="AreaConfirm"
          @cancel="showArea = false"
        />
      </Popup>
      <Popup v-model="showSex" position="bottom">
        <Picker
          show-toolbar
          :columns="sexList"
          value-key="label"
          @confirm="sexConfirm"
          @cancel="showSex = false"
        />
      </Popup>
      <Popup v-model="showBirthDate" position="bottom">
        <DatetimePicker
          type="date"
          title="选择年月日"
          :min-date="minDate"
          :max-date="maxDate"
          v-model="currentDate"
          @confirm="birthDateConfirm"
          @cancel="showBirthDate = false"
        />
      </Popup>
    </div>
  </CustomPage>
</template>

<script>
import Compressor from "compressorjs";
import { areaList } from "@vant/area-data";
import CustomPage from "@/components/custom-page.vue";
import { uploadImage } from "@/api/index";
import { getInfo, updateInfo } from "@/api/setting/index";
import { vaildName, validPhone } from "@/utils/vaildate";
import {
  Form,
  Field,
  Uploader,
  Popup,
  Area,
  Picker,
  DatetimePicker,
  Notify,
} from "vant";
export default {
  components: {
    CustomPage,
    Form,
    Field,
    Uploader,
    Popup,
    Area,
    Picker,
    DatetimePicker,
  },
  data() {
    return {
      vaildName,
      validPhone,
      showArea: false,
      showSex: false,
      showBirthDate: false,
      areaList,
      sexList: [
        { value: 0, label: "男" },
        { value: 1, label: "女" },
      ],
      minDate: new Date("1900-01-01"),
      maxDate: new Date(),
      currentDate: new Date("2000-01-01"),
      form: {
        id: null,
        file: null,
        avatar: null,
        name: null,
        area: null,
        areaName: null,
        address: null,
        contactName: null,
        contactPhone: null,
        sex: null,
        birthDate: null,
      },
    };
  },
  created() {
    this.getData();
  },
  computed: {
    avatar_c() {
      return this.form.avatar || require("@/assets/setting/avatar.png");
    },
    sex_c() {
      return this.form.sex !== null
        ? this.sexList.find((item) => item.value === Number(this.form.sex))[
            "label"
          ]
        : null;
    },
  },
  methods: {
    getData() {
      getInfo(this.$store.state.user.customerId).then((res) => {
        const data = res.data;
        this.form.id = data.id;
        this.form.name = data.name;
        this.form.area = data.address && data.address.toString();
        this.form.address = data.detailedAddress;
        this.form.contactName = data.contactName;
        this.form.contactPhone = data.mobile;
        this.form.sex = data.sex;
        data.imgUrl && (this.form.avatar = data.imgUrl);
        if (data.address) {
          const county = this.areaList.county_list[data.address];
          const city =
            this.areaList.city_list[
              data.address.toString().substr(0, 4) + "00"
            ];
          const province =
            this.areaList.province_list[
              data.address.toString().substr(0, 2) + "0000"
            ];
          this.form.areaName = `${province} ${city} ${county}`;
        }
        if (data.birthDate) {
          const datetime = this.dayjs(data.birthDate).format("YYYY-MM-DD")
          this.currentDate = new Date(datetime);
          this.form.birthDate = datetime
        }
        this.form.file = null;
      });
    },
    onSubmit() {
      this.$refs.form
        .validate()
        .then((res) => {
          this.submitForm();
        })
        .catch((err) => {
          Notify("信息填写有误");
        });
    },
    async submitForm() {
      this.$store.dispatch("app/showLoading");
      let imgUrl = this.form.avatar;
      if (this.form.file) {
        try {
          imgUrl = await this.uploadAvatar(this.form.file);
        } catch (error) {
          this.$store.dispatch("app/hideLoading");
        }
      }
      const params = {
        id: this.form.id,
        name: this.form.name,
        address: this.form.area,
        detailedAddress: this.form.address,
        contactName: this.form.contactName,
        mobile: this.form.contactPhone,
        sex: this.form.sex,
        imgUrl: imgUrl,
        birthDate: this.form.birthDate ? this.dayjs(this.form.birthDate).format('YYYY-MM-DD HH:mm:ss') : null,
      };
      updateInfo(params)
        .then((res) => {
          Notify({ type: "success", message: "保存成功" });
          this.$store.dispatch('user/getUserInfoDetail', this.$store.state.user.customerId)
          this.$store.dispatch("app/hideLoading");
        })
        .catch(() => this.$store.dispatch("app/hideLoading"));
    },
    uploadAvatar(file) {
      return new Promise((resolve, reject) => {
        const params = new FormData();
        params.append("file", file);
        uploadImage(params)
          .then((res) => {
            resolve(res.data);
          })
          .catch(reject);
      });
    },
    AreaConfirm(val) {
      const list = val.map((item) => item.name);
      this.form.areaName = list.join(" ");
      this.form.area = val[val.length - 1]["code"];
      this.showArea = false;
    },
    sexConfirm(val) {
      this.form.sex = val.value;
      this.showSex = false;
    },
    birthDateConfirm(val) {
      this.form.birthDate = this.dayjs(val).format('YYYY-MM-DD');
      this.showBirthDate = false;
    },
    afterRead(file) {
      this.form.avatar = file.content;
      new Compressor(file.file, {
        quality: 0.6,
        success: (result) => {
          this.form.file = result;
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  .avatar {
    width: 120px;
    height: 120px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .van-form {
    .van-cell {
      font-size: 28px;
      line-height: 1em;
      padding: 28px 24px;
      /deep/ .van-field__label {
        color: #333333;
      }
      &::after {
        border-color: #f2f2f2;
      }
    }
  }
}
</style>